import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PromiseResult } from '../models/PromiseResult';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  storeLinks : any[] = null;

  constructor(private readonly http: HttpClient) { }

  isMobile() : number
  {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|windows phone|Opera Mini/i.test(navigator.userAgent)){
          if (/iPhone|iPad|iPod/i.test(navigator.userAgent))
          {
              return 1;
          }else if (/Android/i.test(navigator.userAgent)) {
            return 2;
          }
          return 3;
    }
    else{
          return 0;
    }
  }

  async mobileAppLinks() : Promise<any[]>
  {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|windows phone|Opera Mini/i.test(navigator.userAgent)){
          if (/iPhone|iPad|iPod/i.test(navigator.userAgent))
          {
              await this.getAppLinks().then(storelinks => {
                this.storeLinks = storelinks.filter(object => {
                    return object['deviceType'] == "ios";
              });
            });
          }else if (/Android/i.test(navigator.userAgent)) {
              await this.getAppLinks().then(storelinks => {
                this.storeLinks = storelinks.filter(object => {
                    return object['deviceType'] == "android";
              });
            });
          }
          return this.storeLinks;
    }
    else{
          return null;
    }
  }


  async getAppLinks() {
    return this.http.get<PromiseResult>('assets/data/appLinks.json')
      .toPromise()
      .then(res => res.data as any[])
      .then(data => data);
    }
}
